import React from 'react';
import { MocDashboardKPIs } from './types';

interface Props {
  kpis: MocDashboardKPIs | null;
  onRefresh?: () => void;
}

export const MocMetricsCards: React.FC<Props> = ({ kpis, onRefresh: _onRefresh }) => {
  if (!kpis) return null;

  return (
    <div className="stats-grid">
      <div className="stat-card">
        <span className="stat-label">Active Changes</span>
        <span className="stat-value" style={{ color: '#2563eb' }}>{kpis.active_changes}</span>
        <span className="stat-sub">{kpis.total_changes} Total Portfolio</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Draft & Screening</span>
        <span className="stat-value" style={{ color: '#d97706' }}>{kpis.draft_screening_changes}</span>
        <span className="stat-sub">Impact assessment stage</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Pending Approval</span>
        <span className="stat-value" style={{ color: '#7c3aed' }}>{kpis.in_approval_changes}</span>
        <span className="stat-sub">Management / SoD signoff</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">In Implementation</span>
        <span className="stat-value" style={{ color: '#0284c7' }}>{kpis.in_implementation_changes}</span>
        <span className="stat-sub">Execution in progress</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Closed & PIR</span>
        <span className="stat-value" style={{ color: '#059669' }}>{kpis.closed_changes}</span>
        <span className="stat-sub">Avg Effectiveness: %{kpis.average_effectiveness_score}</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Overdue & Emergency</span>
        <span className="stat-value" style={{ color: kpis.overdue_changes_count > 0 ? '#dc2626' : '#64748b' }}>
          {kpis.overdue_changes_count}
        </span>
        <span className="stat-sub">{kpis.emergency_changes_count} Emergency changes</span>
      </div>
    </div>
  );
};
